const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/getting-started/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
const gettingStartedSearchSchema = z.object({
  show_confetti: z.boolean().optional().catch(undefined)
});
export const Route = createFileRoute("/_protected/getting-started/")({
  validateSearch: gettingStartedSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});